import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import classNames from 'classnames';
import type {Datapoint} from '@deviceinsight/ng-ui-api-client';
import '@deviceinsight/ng-ui-api-client';
import {Button} from '@deviceinsight/ng-ui-basic-components';
import type {InfoWidgetDatapoint} from '../../types';
import datapointIcon from '../../../../../assets/icon-datapoint.png';
import {decimalPointsInRange} from '../ConfigUtils';
import {TFunction, WidgetProps} from '@deviceinsight/ng-ui-scale-lib/api';

type DatapointButtonProps = {
	datapoint: Datapoint | null | undefined;
	context: WidgetProps['context'];
	onClick: () => void;
};
type DatapointConfigProps = {
	item: InfoWidgetDatapoint;
	context: WidgetProps['context'];
	onSelectDatapoint: () => void;
	onDecimalPointChange: (arg0: React.ChangeEvent<HTMLInputElement>) => void;
	t: TFunction;
};

const SelectDatapointButton = ({datapoint, context, onClick}: DatapointButtonProps) => {
	const textAlign = datapoint ? 'left' : 'center';
	const title = datapoint
		? datapoint.name
		: {
				id: 'dashboard.widgets.config.selectDatapoint',
				defaultValue: 'Select Datapoint'
		  };
	const label = datapoint ? (
		<span title={datapoint.name}>{datapoint.name}</span>
	) : (
		<span>
			<Trans i18nKey="dashboard.widgets.config.selectDatapoint">Select Datapoint</Trans>
		</span>
	);
	const isWideButton = !datapoint || datapoint.datatype !== 'DOUBLE';
	const buttonClass = classNames({
		wide: isWideButton
	});
	const asset = context.type === 'asset' ? context.asset : undefined;
	return (
		<Button
			onClick={onClick}
			title={title}
			style={{
				textAlign: textAlign
			}}
			className={buttonClass}
			disabled={!asset}>
			{datapoint && <img src={datapointIcon} alt="datapoint" className="datasource-icon" />}
			{label}
		</Button>
	);
};

const DatapointConfig = ({item, context, onSelectDatapoint, onDecimalPointChange, t}: DatapointConfigProps) => {
	const isDecimal = item.datapoint && item.datapoint.datatype === 'DOUBLE';
	const valid = isDecimal && decimalPointsInRange(item.decimalPoints);
	const decimalClass = classNames({
		error: !valid
	});
	const decimalTitle = valid
		? t('dashboard.widgets.config.info.decimalPoints', {
				defaultValue: 'Decimal Points'
		  })
		: t('dashboard.widgets.config.info.decimalPoints.error', {
				defaultValue: 'Decimal Points must be a number between 0 and 5'
		  });
	return (
		<td className="datapoint-selector">
			<div className="datapoint-items">
				<SelectDatapointButton datapoint={item.datapoint} onClick={onSelectDatapoint} context={context} />
				{isDecimal && (
					<input
						type="number"
						value={item.decimalPoints}
						onChange={onDecimalPointChange}
						min={0}
						max={5}
						maxLength={1}
						className={decimalClass}
						title={decimalTitle}
					/>
				)}
			</div>
		</td>
	);
};

export default DatapointConfig;
